/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Contact_Code_Trees_Children_CoundInputs */

const en_tables_contact_code_trees_children_cound = /** @type {(inputs: Tables_Contact_Code_Trees_Children_CoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cound`)
};

const de_tables_contact_code_trees_children_cound = /** @type {(inputs: Tables_Contact_Code_Trees_Children_CoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cound`)
};

/**
* | output |
* | --- |
* | "Cound" |
*
* @param {Tables_Contact_Code_Trees_Children_CoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_contact_code_trees_children_cound = /** @type {((inputs?: Tables_Contact_Code_Trees_Children_CoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Contact_Code_Trees_Children_CoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_contact_code_trees_children_cound(inputs)
	return de_tables_contact_code_trees_children_cound(inputs)
});